<template>
  <el-container style="height: 100vh" class="layout-container">
    <!-- 添加水印组件 -->
    <watermark
        :text="watermarkText"
        :font-size="16"
        :rotate="-25"
        :gap-x="200"
        :gap-y="150"
        color="rgba(0, 0, 0, 0.06)"
    />

    <!-- 侧边栏 -->
    <el-aside :width="sidebarCollapse ? '64px' : '220px'" style="background-color: #1f2937; transition: width 0.3s">
      <div class="logo" style="height: 60px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 16px; font-weight: bold; border-bottom: 1px solid #374151">
        <img
            src="/logo.png"
            alt="logo"
            style="width: 42px; height: 42px; margin-right: 8px; padding: 4px; border-radius: 8px"
            v-if="!sidebarCollapse"
        >
        <span v-if="!sidebarCollapse">合聚联销ERP</span>
        <img
            src="/logo.png"
            alt="logo"
            style="width: 42px; height: 42px; filter: drop-shadow(0 0 4px rgba(255,255,255,0.3))"
            v-else
        >
      </div>
      <el-menu
          :default-active="$route.path"
          background-color="#1f2937"
          text-color="#d1d5db"
          active-text-color="#3b82f6"
          :collapse="sidebarCollapse"
          router
          :collapse-transition="false"
      >
        <template v-for="menu in permissionMenuList">
          <!-- 有子菜单 -->
          <el-submenu
              v-if="menu.childrenList && menu.childrenList.length && hasPerm(menu.permission)"
              :key="menu.permissionId"
              :index="String(menu.permissionId)"
          >
            <template slot="title">
              <i :class="menu.icon"></i>
              <span>{{ menu.permissionName }}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item
                v-for="subMenu in menu.childrenList"
                :key="subMenu.permissionId"
                :index="subMenu.pageUrl"
                v-if="hasPerm(subMenu.permission)"
            >
              <i :class="subMenu.icon"></i>
              <span slot="title">{{ subMenu.permissionName }}</span>
            </el-menu-item>
          </el-submenu>

          <!-- 无子菜单 -->
          <el-menu-item
              v-else-if="hasPerm(menu.permission)"
              :key="menu.permissionId"
              :index="menu.pageUrl"
          >
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.permissionName }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶部导航 -->
      <el-header style="background: #fff; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: space-between; padding: 0 20px">
        <div style="display: flex; align-items: center">
          <i :class="sidebarCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" style="font-size: 20px; cursor: pointer" @click="$store.commit('TOGGLE_SIDEBAR')"></i>
          <el-breadcrumb separator="/" style="margin-left: 16px">
            <el-breadcrumb-item>{{ currentMenuName || '首页' }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div style="display: flex; align-items: center; gap: 16px">
          <!-- 添加公告图标 -->
          <el-button type="text" style="padding: 0; color: #374151" @click="openAnnouncementDialog" v-if="hasPerm('system:initiateAnnouncement')">
            <i class="el-icon-document" style="font-size: 20px"></i>
          </el-button>
          <!-- 消息通知 -->
          <el-badge :value="totalUnreadCount" :hidden="totalUnreadCount <= 0" :max="99">
            <el-button type="text" style="padding: 0; color: #374151" @click="openNoticeDialog">
              <i class="el-icon-bell" style="font-size: 20px"></i>
            </el-button>
          </el-badge>
          <span style="color: #6b7280; font-size: 13px">{{ username }}</span>
          <el-dropdown @command="handleCommand">
            <el-avatar :size="32" icon="el-icon-user-solid" style="cursor: pointer"></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主内容区 -->
      <el-main style="background: #f3f4f6; padding: 0; overflow: hidden;">
        <tabs-view v-if="menuLoaded" />
        <div v-else class="loading-container" v-loading="true" element-loading-text="加载菜单中..."></div>
      </el-main>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="pwdDialogVisible" width="440px" :close-on-click-modal="false" @closed="resetPwdForm">
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPasswordConfirm">
          <el-input v-model="pwdForm.newPasswordConfirm" type="password" show-password autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pwdDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="pwdSubmitting" @click="submitPwd">确定</el-button>
      </span>
    </el-dialog>

    <!-- 添加文本公告弹窗 -->
    <el-dialog
        title="发布公告"
        :visible.sync="announcementDialogVisible"
        width="600px"
        :close-on-click-modal="false"
        @closed="resetAnnouncementForm"
    >
      <el-form ref="announcementForm" :model="announcementForm" :rules="announcementRules" label-width="80px">
        <!-- 公告内容 -->
        <el-form-item label="公告内容" prop="content">
          <el-input
              v-model="announcementForm.content"
              type="textarea"
              :rows="8"
              placeholder="请输入公告内容，支持换行"
              maxlength="500"
              show-word-limit
          ></el-input>
        </el-form-item>

        <!-- 开始时间 -->
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
              v-model="announcementForm.startTime"
              type="date"
              placeholder="请选择开始时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%"
              :picker-options="startTimePickerOptions"
          ></el-date-picker>
          <div style="color: #909399; font-size: 12px; margin-top: 4px">
            不选则立即生效
          </div>
        </el-form-item>

        <!-- 结束时间 -->
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
              v-model="announcementForm.endTime"
              type="date"
              placeholder="请选择结束时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%"
              :picker-options="endTimePickerOptions"
          ></el-date-picker>
          <div style="color: #909399; font-size: 12px; margin-top: 4px">
            不选则长期有效
          </div>
        </el-form-item>

        <!-- 需要确认 -->
        <el-form-item label="需要确认" prop="needConfirm">
          <el-radio-group v-model="announcementForm.needConfirm">
            <el-radio :label="1">需要确认</el-radio>
            <el-radio :label="0">不需要确认</el-radio>
          </el-radio-group>
          <div style="color: #909399; font-size: 12px; margin-top: 4px">
            需要确认：用户必须点击"我已知晓"按钮才能关闭公告
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="announcementDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="announcementSubmitting" @click="submitAnnouncement">发布</el-button>
      </span>
    </el-dialog>

    <!-- 文本通知弹窗 -->
    <el-dialog
        title="系统通知"
        :visible.sync="textNoticeDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :show-close="showClose"
        :before-close="handleTextNoticeClose"
    >
      <div class="notice-content text-notice">
        <div class="notice-icon">
          <i class="el-icon-info"></i>
        </div>
        <div class="notice-message" style="white-space: pre-wrap;">
          {{ currentTextNotice.noticeText }}
        </div>
        <div class="notice-time" v-if="currentTextNotice.createTime">
          {{ currentTextNotice.createTime }}
        </div>
      </div>
      <span slot="footer">
    <el-button
        :type="countdown > 0 ? 'info' : 'primary'"
        :disabled="countdown > 0"
        :loading="textNoticeAcking"
        @click="ackCurrentTextNotice"
    >
      {{ countdown > 0 ? `我已知晓 (${countdown}s)` : '我已知晓' }}
    </el-button>
  </span>
    </el-dialog>

    <!-- 价格变动提醒弹窗 -->
    <el-dialog
        title="价格变动提醒"
        :visible.sync="priceChangeNoticeDialogVisible"
        width="1100px"
        :close-on-click-modal="false"
        :show-close="false"
        @close="closePriceNotice"
    >
      <div v-loading="priceNoticeLoading">
        <div class="notice-header price-notice-header">
          <i class="el-icon-warning" style="color: #e6a23c; font-size: 20px; margin-right: 8px"></i>
          <span style="color: #e6a23c; font-weight: bold">当前价格变动提醒如下，请及时确认</span>
        </div>
        <el-table :data="priceChangeNotice.noticeList" border size="mini" max-height="420" style="margin-top: 12px" v-loading="priceChangeNotice.priceLoading">
          <el-table-column prop="createTime" label="时间" min-width="160"></el-table-column>
          <el-table-column prop="spuCode" label="SPU" min-width="140"></el-table-column>
          <el-table-column prop="skcCode" label="SKC" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="skuCode" label="SKU" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="typeDescription" label="价格类型" min-width="120">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; gap: 6px">
                <i
                    :class="getPriceTypeIcon(scope.row.typeDescription)"
                    :style="{ color: getPriceTypeColor(scope.row.typeDescription), fontSize: '16px' }"
                ></i>
                <span>{{ scope.row.typeDescription }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="oldValue" label="原值" min-width="80"></el-table-column>
          <el-table-column prop="newValue" label="现值" min-width="150">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; gap: 6px">
                <span>{{ scope.row.newValue }}</span>
                <!-- 升降标识带百分比 -->
                <span
                    v-if="Number(scope.row.newValue) > Number(scope.row.oldValue)"
                    style="color: #f56c6c; display: flex; align-items: center; gap: 2px"
                >
                  <i class="el-icon-top"></i>
                  <span style="font-size: 12px">
                    +{{ calculatePercent(scope.row.newValue, scope.row.oldValue) }}%
                  </span>
                </span>
                          <span
                              v-else-if="Number(scope.row.newValue) < Number(scope.row.oldValue)"
                              style="color: #67c23a; display: flex; align-items: center; gap: 2px"
                          >
                  <i class="el-icon-bottom"></i>
                  <span style="font-size: 12px">
                    {{ calculatePercent(scope.row.newValue, scope.row.oldValue) }}%
                  </span>
                </span>
                          <span v-else style="color: #909399">
                  <i class="el-icon-remove"></i>
                  <span style="font-size: 12px">持平</span>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

<!--        <div style="margin-top: 12px; text-align: right">-->
<!--          <el-pagination-->
<!--              background-->
<!--              layout="total, prev, pager, next"-->
<!--              :total="priceChangeNotice.total"-->
<!--              :page-size="priceChangeNotice.pageSize"-->
<!--              :current-page.sync="priceChangeNotice.pageNum"-->
<!--              @current-change="fetchPriceNotices">-->
<!--          </el-pagination>-->
<!--        </div>-->
      </div>
      <span slot="footer">
        <el-button
            :type="priceCountdown > 0 ? 'info' : 'primary'"
            :disabled="priceCountdown > 0"
            :loading="priceChangeNotice.noticeAcking"
            @click="ackPriceNotices"
        >
          {{ priceCountdown > 0 ? `我已知晓 (${priceCountdown}s)` : '我已知晓' }}
        </el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  sendChangePasswordSms,
  changePasswordBySms,
  ackPriceChangeNotices,
  getPermissionMenuList,
  getSysNoticeList1,
  getSysNoticeList2,
  ackTextNotice, addNotice, getTotalUnreadCount  // 需要导入文本通知确认接口
} from '@/api'

import Watermark from '@/components/Watermark.vue'
import {hasPerm} from "@/utils/permission";
import TabsView from '@/components/TabsView.vue'

export default {
  name: 'Layout',
  components: {
    Watermark,
    TabsView
  },
  data() {
    const confirmPwd = (rule, value, callback) => {
      if (!value) return callback(new Error('请再次输入密码'))
      if (value !== this.pwdForm.newPassword) return callback(new Error('两次密码不一致'))
      callback()
    }
    return {
      // 公告相关
      showClose: false,
      announcementDialogVisible: false,
      announcementSubmitting: false,
      announcementForm: {
        content: '',
        needConfirm: 1,
        startTime: '',
        endTime: ''
      },
      announcementRules: {
        content: [
          { required: true, message: '请输入公告内容', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ],
        startTime: [
          {
            validator: (rule, value, callback) => {
              if (value && this.announcementForm.endTime) {
                if (new Date(value) > new Date(this.announcementForm.endTime)) {
                  callback(new Error('开始时间不能晚于结束时间'))
                }
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: (rule, value, callback) => {
              if (value && this.announcementForm.startTime) {
                if (new Date(this.announcementForm.startTime) > new Date(value)) {
                  callback(new Error('结束时间不能早于开始时间'))
                }
              }
              callback()
            },
            trigger: 'change'
          }
        ]
      },
      // 价格变动通知相关
      priceChangeNotice: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        noticeAcking: false,
        noticeList: [],
        priceLoading: false
      },
      totalUnreadCount: 0,
      priceChangeNoticeDialogVisible: false,
      priceNoticeLoading: false,
      priceCountdown: 0,
      priceCountdownTimer: null,
      handOpenNoticeDialog: false,

      // 文本通知相关
      textNoticeList: [],      // 所有未读文本通知列表
      currentTextNoticeIndex: 0,  // 当前显示的第几条
      textNoticeDialogVisible: false,
      textNoticeAcking: false,
      countdown: 0,
      countdownTimer: null,

      menuLoaded: false,
      currentMenuName: '',
      pwdDialogVisible: false,
      pwdSubmitting: false,
      pwdSending: false,
      pwdLeftSec: 0,
      pwdTimer: null,
      pwdForm: { newPassword: '', newPasswordConfirm: '', smsCode: '' },

      noticeLoading: false,
      noticeTab: 'all',
      permissionMenuList: [],
      noticeTimer: null,
      pwdRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '至少6位', trigger: 'blur' }
        ],
        newPasswordConfirm: [{ required: true, validator: confirmPwd, trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        this.updateCurrentMenuName(newPath)
      },
      immediate: true
    },
    permissionMenuList: {
      handler() {
        this.updateCurrentMenuName(this.$route.path)
      },
      deep: true
    }
  },
  computed: {
    menuPathMap() {
      const map = new Map()
      const buildMap = (list) => {
        for (const menu of list) {
          if (menu.pageUrl) map.set(menu.pageUrl, menu.permissionName)
          if (menu.childrenList) buildMap(menu.childrenList)
        }
      }
      buildMap(this.permissionMenuList)
      return map
    },
    sidebarCollapse() { return this.$store.state.sidebarCollapse },
    username() { return this.$store.getters.username },
    role() { return this.$store.getters.role },
    permCodes() { return this.$store.getters.permCodes },
    userId() { return this.$store.getters.userId },
    currentTextNotice() {
      if (this.textNoticeList.length > 0 && this.currentTextNoticeIndex < this.textNoticeList.length) {
        return this.textNoticeList[this.currentTextNoticeIndex]
      }
      return {}
    },
    watermarkText() {
      const username = this.username || '未登录用户'
      const now = new Date()
      const dateStr = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${now.getHours()}:${now.getMinutes()}`
      return `${username}`
      // return `${username} ${dateStr}`
    }
    // totalUnreadCount() {
    //   return this.textNoticeList.length + (this.priceChangeNotice.total || 0)
    // }
  },
  mounted() {
    this.getPermissionMenuList()
    this.menuLoaded = true
    this.checkAllNotices()
  },
  beforeDestroy() {
    if (this.pwdTimer) {
      clearInterval(this.pwdTimer)
      this.pwdTimer = null
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
    if (this.priceCountdownTimer) {
      clearInterval(this.priceCountdownTimer)
      this.priceCountdownTimer = null
    }
  },
  methods: {
    startTimePickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      }
    },
    endTimePickerOptions() {
      return {
        disabledDate: (time) => {
          if (this.announcementForm.startTime) {
            return time.getTime() < new Date(this.announcementForm.startTime).getTime()
          }
          return false
        }
      }
    },
    async getTotalUnreadCount() {
      try {
        const res = await getTotalUnreadCount()
        this.totalUnreadCount = res.data || 0
      } catch (e) {

      }
    },
    // // 检查是否需要显示通知（是否有缓存）
    // shouldShowNotices() {
    //   const lastShowTime = localStorage.getItem('notices_last_show_time')
    //   if (!lastShowTime) {
    //     return true  // 没有缓存，需要显示
    //   }
    //   const now = new Date().getTime()
    //   const twoHours = 2 * 60 * 60 * 1000  // 2小时的毫秒数
    //   return (now - parseInt(lastShowTime)) > twoHours  // 超过2小时才显示
    // },

    // // 保存显示时间
    // saveNoticesShowTime() {
    //   localStorage.setItem('notices_last_show_time', new Date().getTime().toString())
    // },
    //
    // // 清除缓存（如果需要手动清除）
    // clearNoticesCache() {
    //   localStorage.removeItem('notices_last_show_time')
    // },

    hasPerm,
    handleCommand(cmd) {
      if (cmd === 'logout') {
        // this.clearNoticesCache()
        this.$store.commit('LOGOUT')
        this.$router.push('/login')
      } else if (cmd === 'password') {
        this.pwdDialogVisible = true
      }
    },
    resetPwdForm() {
      this.pwdForm = { newPassword: '', newPasswordConfirm: '', smsCode: '' }
      this.$nextTick(() => this.$refs.pwdForm && this.$refs.pwdForm.clearValidate())
    },
    async sendPwdSms() {
      this.pwdSending = true
      try {
        await sendChangePasswordSms()
        this.$message.success('验证码已发送')
        this.pwdLeftSec = 60
        if (this.pwdTimer) clearInterval(this.pwdTimer)
        this.pwdTimer = setInterval(() => {
          this.pwdLeftSec--
          if (this.pwdLeftSec <= 0) {
            clearInterval(this.pwdTimer)
            this.pwdTimer = null
          }
        }, 1000)
      } finally {
        this.pwdSending = false
      }
    },
    submitPwd() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) return
        this.pwdSubmitting = true
        try {
          await changePasswordBySms({
            newPassword: this.pwdForm.newPassword,
            newPasswordConfirm: this.pwdForm.newPasswordConfirm,
            smsCode: this.pwdForm.smsCode
          })
          this.$message.success('密码已修改，请重新登录')
          this.pwdDialogVisible = false
          this.$store.commit('LOGOUT')
          this.$router.push('/login')
        } catch (e) {
        } finally {
          this.pwdSubmitting = false
        }
      })
    },

    async getPermissionMenuList() {
      try {
        const res = await getPermissionMenuList()
        this.permissionMenuList = res.data || []
        this.$store.commit('SET_PERMISSION_MENU', this.permissionMenuList)
        this.updateCurrentMenuName(this.$route.path)
      } catch (e) {
        this.permissionMenuList = []
      }
    },
    updateCurrentMenuName(path) {
      const name = this.menuPathMap.get(path)
      this.currentMenuName = name || path.split('/').pop() || '首页'
    },

    // ==================== 通知相关方法 ====================

    async checkAllNotices() {
      this.getTotalUnreadCount()

      // 检查缓存，2小时内不再弹窗（手动打开通知时跳过缓存检查）
      // if (!this.handOpenNoticeDialog && !this.shouldShowNotices()) {
      //   return
      // }

      await this.fetchTextNotices()
      if (this.textNoticeList.length === 0) {
        await this.fetchPriceNotices()
      }

      // 有通知时才保存时间（手动打开时也保存，避免重复弹）
      // if (this.textNoticeList.length > 0 || this.priceChangeNotice.noticeList.length > 0) {
      //   this.saveNoticesShowTime()
      // }

      // 重置手动打开标记
      this.handOpenNoticeDialog = false
    },

    async fetchTextNotices() {
      try {
        this.showClose = false
        const res = await getSysNoticeList2()
        this.textNoticeList = res.data || res.rows || []
        if (this.textNoticeList.length > 0) {
          this.currentTextNoticeIndex = 0
          this.textNoticeDialogVisible = true
          this.startCountdown()

          const nowCurrentNotice = this.textNoticeList[0]
          if (nowCurrentNotice.needConfirm === 1) {
            this.showClose = false
          } else {
            this.showClose = true
          }
        }
      } catch (e) {
        console.error('获取文本通知失败', e)
        this.textNoticeList = []
      }
    },

    startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
      this.countdown = 5
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
      }, 1000)
    },

    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      this.countdown = 0
    },

    // 确认当前文本通知
    async ackCurrentTextNotice() {
      if (this.countdown > 0) {
        this.$message.warning(`请等待${this.countdown}秒后再确认`)
        return
      }

      this.textNoticeAcking = true
      try {
        const currentNotice = this.currentTextNotice
        // 调用确认接口
        if (currentNotice.id && currentNotice.needConfirm === 1) {
          await ackPriceChangeNotices({ noticeIds : [currentNotice.id] })
        }
        this.getTotalUnreadCount()
        // 确认后从列表中移除当前通知
        this.textNoticeList.splice(this.currentTextNoticeIndex, 1)

        if (this.textNoticeList.length > 0 && this.currentTextNoticeIndex < this.textNoticeList.length) {
          // 还有下一条，重置倒计时继续显示（弹窗保持打开）
          this.startCountdown()

          const nowCurrentNotice = this.textNoticeList[0]
          if (nowCurrentNotice.needConfirm === 1) {
            this.showClose = false
          } else {
            this.showClose = true
          }
        } else if (this.textNoticeList.length === 0) {
          // 所有文本通知都已展示完毕，关闭弹窗，继续获取价格通知
          this.textNoticeDialogVisible = false
          this.stopCountdown()
          this.currentTextNoticeIndex = 0
          await this.fetchPriceNotices()
        } else {
          // 索引超出，说明是最后一条被删除了
          this.textNoticeDialogVisible = false
          this.stopCountdown()
          this.currentTextNoticeIndex = 0
          await this.fetchPriceNotices()
        }
      } catch (e) {
        this.$message.error('确认失败')
      } finally {
        this.textNoticeAcking = false
      }
    },

    async fetchPriceNotices() {
      try {
        this.priceChangeNotice.priceLoading = true

        const res = await getSysNoticeList1({
          pageNum: this.priceChangeNotice.pageNum,
          pageSize: this.priceChangeNotice.pageSize
        })
        this.priceChangeNotice.noticeList = res.data || []
        this.priceChangeNotice.priceLoading = false

        if (this.priceChangeNotice.noticeList.length > 0) {
          this.priceChangeNoticeDialogVisible = true
          this.startPriceCountdown()
        }else {
          this.stopPriceCountdown()
          this.priceChangeNoticeDialogVisible = false

          if (this.handOpenNoticeDialog) {
            this.$alert('暂无通过的数据', '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            })
          }

        }
      } catch (e) {
        this.priceChangeNotice.noticeList = []
        this.priceChangeNotice.total = 0
        this.priceChangeNotice.priceLoading = false
      }
    },

    startPriceCountdown() {
      if (this.priceCountdownTimer) {
        clearInterval(this.priceCountdownTimer)
      }
      this.priceCountdown = 3
      this.priceCountdownTimer = setInterval(() => {
        this.priceCountdown--
        if (this.priceCountdown <= 0) {
          clearInterval(this.priceCountdownTimer)
          this.priceCountdownTimer = null
        }
      }, 1000)
    },

    stopPriceCountdown() {
      if (this.priceCountdownTimer) {
        clearInterval(this.priceCountdownTimer)
        this.priceCountdownTimer = null
      }
      this.priceCountdown = 0
    },

    async ackPriceNotices() {
      if (this.priceCountdown > 0) {
        this.$message.warning(`请等待${this.priceCountdown}秒后再确认`)
        return
      }
      this.priceChangeNotice.noticeAcking = true
      try {
        const noticeIds = this.priceChangeNotice.noticeList.map(item => item.id).filter(id => id)
        if (noticeIds.length > 0) {
          await ackPriceChangeNotices({noticeIds : noticeIds})
        }
        this.getTotalUnreadCount()
        this.stopPriceCountdown()
        this.priceChangeNotice = {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          noticeAcking: false,
          noticeList: [],
          priceLoading: false
        }
        await this.fetchPriceNotices()

      } catch (e) {
        this.$message.error('确认失败')
      } finally {
        this.priceChangeNotice.noticeAcking = false
      }
    },

    // 关闭价格通知（只是关闭弹窗，不清除数据）
    closePriceNotice() {
      this.stopPriceCountdown()
      this.priceChangeNoticeDialogVisible = false
      // 注意：不清空 priceChangeNotice 的数据
    },

    async openNoticeDialog() {
      this.handOpenNoticeDialog = true
      await this.checkAllNotices()
    },

    // 拦截文本通知的关闭事件（点击X关闭）
    handleTextNoticeClose(done) {
      this.stopCountdown()
      const currentNotice = this.currentTextNotice

      if (currentNotice.needConfirm === 1) {
        // needConfirm === 1：不清除条数，只跳到下一条
        // 不调用 splice，只是索引后移
        this.currentTextNoticeIndex++

        if (this.currentTextNoticeIndex < this.textNoticeList.length) {
          // 还有下一条，弹窗保持打开
          done(false)  // 阻止关闭
          this.startCountdown()
        } else {
          // 没有下一条了，关闭弹窗，请求价格接口
          done()
          this.currentTextNoticeIndex = 0
          this.fetchPriceNotices()
        }
      } else {
        // needConfirm !== 1：清除条数，跳到下一条
        this.textNoticeList.splice(this.currentTextNoticeIndex, 1)

        if (this.textNoticeList.length > 0 && this.currentTextNoticeIndex < this.textNoticeList.length) {
          // 还有下一条，弹窗保持打开
          done(false)  // 阻止关闭
          this.startCountdown()
        } else {
          // 没有下一条了，关闭弹窗，请求价格接口
          done()
          this.currentTextNoticeIndex = 0
          this.fetchPriceNotices()
        }
      }

      const nowCurrentNotice = this.textNoticeList[0]
      if (nowCurrentNotice.needConfirm === 1) {
        this.showClose = false
      } else {
        this.showClose = true
      }
    },
    getPriceTypeIcon(typeDescription) {
      if (typeDescription === '国外拿货' || typeDescription === '国外拿货价') {
        return 'el-icon-s-promotion' // 国外拿货的图标
      } else if (typeDescription === '国内拿货' || typeDescription === '国内拿货价') {
        return 'el-icon-s-shop' // 国内拿货的图标
      }
      return 'el-icon-price-tag'
    },

    getPriceTypeColor(typeDescription) {
      if (typeDescription === '国外拿货' || typeDescription === '国外拿货价') {
        return '#f56c6c' // 红色
      } else if (typeDescription === '国内拿货' || typeDescription === '国内拿货价') {
        return '#67c23a' // 绿色
      }
      return '#909399'
    },
    calculatePercent(newValue, oldValue) {
      const newNum = Number(newValue)
      const oldNum = Number(oldValue)

      // 处理无效值
      if (isNaN(newNum) || isNaN(oldNum) || oldNum === 0) {
        return newNum === oldNum ? '0' : '100'
      }

      return ((newNum - oldNum) / oldNum * 100).toFixed(2)
    },
    // 打开公告弹窗
    openAnnouncementDialog() {
      this.announcementForm = {
        content: '',
        needConfirm: 1
      }
      this.announcementDialogVisible = true
    },

    // 重置公告表单
    resetAnnouncementForm() {
      this.announcementForm = {
        content: '',
        startTime: '',
        endTime: '',
        needConfirm: 1
      }
      this.$nextTick(() => {
        if (this.$refs.announcementForm) {
          this.$refs.announcementForm.clearValidate()
        }
      })
    },

    // 提交公告
    async submitAnnouncement() {
      this.$refs.announcementForm.validate(async valid => {
        if (!valid) return

        this.announcementSubmitting = true
        try {
          // 调用发布公告的接口
          await addNotice({
            noticeText: this.announcementForm.content,  // 公告内容
            needConfirm: this.announcementForm.needConfirm,  // 是否需要确认
            // 补充时间部分
            startTime: this.announcementForm.startTime ? `${this.announcementForm.startTime} 00:00:00` : null,
            endTime: this.announcementForm.endTime ? `${this.announcementForm.endTime} 23:59:59` : null,
            type: 2
          })

          this.$message.success('公告发布成功')
          this.announcementDialogVisible = false
          // 可选：刷新公告列表或通知其他用户
          // this.fetchAnnouncementList()
        } catch (e) {
          this.$message.error('发布失败')
        } finally {
          this.announcementSubmitting = false
        }
      })
    }
  }
}
</script>

<style>
.el-main {
  padding: 0 !important;
  overflow: hidden !important;
}

.notice-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.text-notice .notice-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.text-notice .notice-icon i {
  font-size: 32px;
  color: #fff;
}

.text-notice .notice-message {
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  text-align: center;
  max-height: 300px;
  overflow-y: auto;
  word-break: break-word;
  padding: 0 10px;
}

.text-notice .notice-time {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
}

.notice-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fdf6ec;
  border-radius: 4px;
  border-left: 4px solid #e6a23c;
}

.price-notice-header {
  background: #fdf6ec;
}
</style>